module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAV1BMVEUAAABicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZnHLpMEAAAAHHRSTlMAw4dKaaZ3IpyQ6dzSsFYPzLX19LqViH5nQD476I7DsQAAAHhJREFUKM+t0EkKw0AMRFGpOz0PsTMPuv85E0JhaGVjsP9K8ECLop1zMuQIWVFZQNQQAVVDBZw1nABFQwG8Wgr3ae4X7q3eQprftBTUiZ4sk4k5puwMC/sFDjLEa+D3uIl0ousAR0xmicxGSP5b+YOHIA0hD+Bp3z6NWRTZ7vb6ggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_datainput.png
// module id = hnj5
// module chunks = 9